<template>
  <div class="login">
    <div class="login-form">
      <div class="lg-left"><img src="../assets/images/log.png" class="lgimg" /></div>
      <div class="lg-right">
        <div class="lgForm" :class="[activeName=='0'?'reset1':'reset2']">
          <Vcode :show="isShow" @success="onSuccess" @close="onClose" />
        
          <h3 class="title c3">欢迎登录企胜力</h3>
          <el-tabs v-model="activeName">
            <el-tab-pane label="验证码登录" name="0" >
              <el-form :model="ruleFormCO" :rules="rulesCO" ref="ruleFormCO">
                <el-form-item prop="phone">
                  <el-input
                  class="mmm"
                    v-model="ruleFormCO.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="账号"
                    maxlength="11"
                   
                    @input ="inputCO"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item prop="code" style="position: relative">
                  <el-input
                    v-model="ruleFormCO.code"
                    type="text"
                    auto-complete="off"
                    maxlength="6"
                    placeholder="手机验证码"
                    oninput="value=value.replace(/[^\d]/g,'')" 
                    @keyup.enter.native="submitForm('ruleFormCO')"
                  >
                  </el-input>
                  <div  class="getcode">
                      <el-button
                      @click="showVScod"                   
                      type="primary"                    
                      :disabled="countFlag"
                      :style="{color:(btnMsg==null?'#ccc':'#4B9AFB')}"
                    >
                      {{ btnMsg == null ? countNum + "s" : btnMsg }}
                     </el-button>
                 </div>                   
                </el-form-item>

                <div class="rulela">
                  <el-checkbox v-model="checked" />我已阅读并同意<span @click = "tapClause">《企胜力服务协议》</span>和<span @click = "tapClause">《隐私政策》</span>
                </div>

                <el-form-item style="width: 100%">
                  <el-button
                    :loading="loading1"
                    type="primary"
                    style="width: 100%"
                    @click.native.prevent="submitForm('ruleFormCO')"
                  >
                    <span v-if="!loading1">登 录</span>
                    <span v-else>登 录 中...</span>
                  </el-button>
                </el-form-item>
              </el-form>    
            </el-tab-pane>
            <el-tab-pane label="密码登录" name="1">
              <el-form :model="ruleFormPW" :rules="rulesPW" ref="ruleFormPW">
                <el-form-item prop="phone">
                  <el-input
                    v-model="ruleFormPW.phone"
                    type="text"
                    auto-complete="off"
                    placeholder="账号"
                    maxlength="11"                   
                    @input ="inputPW"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="pwd">
                  <el-input
                    v-model="ruleFormPW.pwd"
                    type="password"
                    auto-complete="off"
                    placeholder="密码"
                    show-password
                    @keyup.enter.native="submitForm('ruleFormPW')"
                  >
                  </el-input>
                </el-form-item>

                <div class="rulela">
                  <el-checkbox v-model="checked" />我已阅读并同意<span @click = "tapClause">《企胜力服务协议》</span>和<span @click = "tapClause">《隐私政策》</span>
                </div>

                <el-form-item style="width: 100%">
                  <el-button
                    :loading="loading2"
                    type="primary"
                    style="width: 100%"
                    @click.native.prevent="submitForm('ruleFormPW')"
                  >
                    <span v-if="!loading2">登 录</span>
                    <span v-else>登 录 中...</span>
                  </el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <div class="reg">
            <div>还没账号？<span @click="open()" >立即注册</span></div>
            <span @click="tapApp()">下载APP</span>
          </div>
        </div>
      </div>
    </div><AudioTip :isTip="isTip"  @hideMe="hideMeHome" isApp="0"/><Clause :clause="clause" @hideClaMe="hideClaMe"/>
  </div>
</template>
<script>
import { getCode } from "@/api/api";
import Cookies from "js-cookie";
import md5 from 'js-md5';
import Vcode from "vue-puzzle-vcode";
import AudioTip from "@/components/AudioTip.vue";
import Clause from "@/components/Clause.vue";
export default {
  components: { AudioTip ,Vcode,Clause },
  data() {
    var check2Phone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    var checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    var check1Phone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    var checkCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    return {
      clause:false,
      isTip:false,
      isShow: false,
      btnMsg:"获取验证码", 
      // 用于倒计时标记，true-正在倒计时
      countFlag:false,
      // 定时器
      intervalBtn:{},
      // 倒计时周期
      countNum:60,
      checked: true,
      activeName: "0",
      ruleFormCO: {
        phone: "",//15810985118",
        code: ""//123456",
      },
      rulesCO: {
        phone: [{ required: true, validator: check1Phone, trigger: "blur" }],
        code: [{ required: true, validator: checkCode, trigger: "blur" }],
      },

      ruleFormPW: {
        phone:"",//" "15811289038",
        pwd:""// "123456",
      },
      rulesPW: {
        phone: [{ required: true, validator: check2Phone, trigger: "blur" }],
        pwd: [{ required: true, validator: checkPwd, trigger: "blur" }],
      },

      loading1: false,
      loading2: false,
    };
  },

  created() {
    // this.getCookie()
  },
  methods: {
    tapClause(){     
      this.clause = true
    },
    hideClaMe(){
      this.clause = false
    },
    hideMeHome(){
      this.isTip = false
    },
    tapApp(){
      this.isTip = true
    },
    inputCO(){      
      // if(this.ruleFormCO.phone.length >= '11'){
       this.ruleFormCO.phone = this.ruleFormCO.phone.replace(/[^\d]/g,'')   
      // }
      console.log(this.ruleFormCO.phone  )
      this.ruleFormPW.phone = this.ruleFormCO.phone       
    },
    inputPW(){
      // if(this.ruleFormPW.phone.length >= '11'){
        this.ruleFormPW.phone = this.ruleFormPW.phone.replace(/[^\d]/g,'')   
      // }
      this.ruleFormCO.phone = this.ruleFormPW.phone
    },
    inputCOde(){     
      // if(this.ruleFormCO.code.length >= '6'){
        // this.ruleFormCO.code = this.ruleFormCO.code.substr(0,6)
      // }
    },
    open(){
      window.location.href = 'https://qiye.yunxuekeji.cn/yunxue_co_backstage/Login/company/index';
    },
    showVScod(){
      if (!this.isCellPhone(this.ruleFormCO.phone)) {        
        this.$message.error('手机号格式错误！');
        return
      }
      this.isShow = true
    },
    onSuccess(msg) {
      this.isShow = false; // 通过验证后，需要手动关闭模态框
      console.log('Success')
      this.getCodePhone()
    },
    onClose() {
      console.log('close')
      this.isShow = false;
    },
    getCodePhone(){      
      var phone = this.ruleFormCO.phone + "";    
      var uuid = 'abcdefdfdf';
			var secrect = 'yxkeji5.0' + uuid;
			var md5str = phone.substring(0, 3) + secrect + phone.substring(phone.length - 4, phone.length);
			md5str = md5(md5str);
			let data = {
				phone:  phone,
				token: md5str,
				secrect: uuid
			};
       getCode(data).then(res => {         
        if(res.code="200"){ 
          this.$message({
            message: '发送成功！',
            type: 'success'
          }); 
          this.countDown()    
        }else{
          this.$message.error(res.msg);
        }                   
      });
    },
     // 倒计时
    countDown(){
        // 设置btn倒计时时显示的信息
        this.btnMsg = null;
        // 更改btn状态
        this.countFlag =! this.countFlag;
        // 设置倒计时
        this.intervalBtn = setInterval(() => {
            if(this.countNum <= 0) {
                // 重置btn提示信息
                this.btnMsg = "获取验证码";
                // 清除定时器
                clearInterval(this.intervalBtn)
                // 更改btn状态
                this.countFlag =! this.countFlag;
                // 重置倒计时状态
                this.countNum = 60;
            };
            // 倒计时
            this.countNum -- ;
        }, 1000);
    },
    isCellPhone(val) {
      var s = val + "";
      var len = s.length;
      if (len != "11" || s.substr(0, 1) != "1") {
        return false;
      } else {
        return true;
      }
    },
    getCookie() {
      // const phone = Cookies.get("phone");
      // this.ruleFormCO.phone = phone === "undefined" ? this.ruleFormCO.phone : phone;
      // this.ruleFormPW.phone = phone === "undefined" ? this.ruleFormPW.phone : phone;
    },
    submitForm(formName) {     
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.checked){
              formName=='ruleFormPW'? this.handleloginPass():this.handleLoginCode()  
          }else{          
            this.$message({
              message: '请阅读企业服务协议并勾选！',
              type: 'warning'
            });
          }         
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleLoginCode() {
      //验证码登录
      var uuid = 'abcdefdfdf';//this.randomString();
      var secrect = "yxkeji5.0" + uuid;
      var phone = this.ruleFormCO.phone + "";
      var md5str =
        phone.substring(0, 3) +
        secrect +
        phone.substring(phone.length - 4, phone.length);
        md5str = md5(md5str);
      let data = {
        phone: phone,
        identCodeSMS: this.ruleFormCO.code,
        deviceId: "H5"//,
       // deviceToken: md5str,
      };
      Cookies.set("phone", this.ruleFormCO.phone, { expires: 30 });
      this.loading1 = true;
      console.log(data)
      this.$store
        .dispatch("loginCode", data)
        .then((res) => {          
          // this.$store.dispatch("GetComp").then(res => {         
             this.$router.push({ path: this.redirect || "/index" })        
          // })
        })
        .catch(() => {
          this.loading1 = false;
        });
    },
    handleloginPass() {
      //密码登录
      var userInfo = {
        phone: this.ruleFormPW.phone,
        pwd: this.ruleFormPW.pwd,
      };
      console.log(userInfo)
      Cookies.set("phone", this.ruleFormPW.phone, { expires: 30 });
      this.loading2 = true;
      this.$store
        .dispatch("loginPass", userInfo)
        .then((res) => {                 
          this.$router.push({ path: this.redirect || "/index" })       
        })
        .catch(() => {
          this.loading2 = false;
        });
    },
  },
};
</script>
<style scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../assets/images/bg.png");
  background-size: cover;
}
.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 1200px;
  display: flex;
}
.lg-left {
  width: 490px;
}

.lgForm {
  width: 466px;
  margin: 0 auto;
  margin-top: 80px;
}
.lg-left img {
  width: 100%;
  display: block;
}
.lg-right {
  flex: 1;
}
.title {
  margin: 0;
  font-size: 30px;
  padding-bottom: 30px;
}
.rulela {
  margin-bottom: 40px;
  color: #999;
  font-size: 19px;
}
.rulela span,
.reg span {
  color: #4b9afb; cursor: pointer
}
.reg {
  font-size: 18px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.getcode {
  position: absolute;
  right: 24px;
  top: 4px;  
}
.getcode>>> .el-button--primary{
  background:#ffffff;
  border:0;
  font-size: 18px;
}
>>> .el-input__suffix {
  right: 20px;
}
>>> .el-checkbox {
  top: -2px;
  margin-right: 10px;
}
>>> .el-input__inner {
  height: 66px;
  font-size: 18px;
  color: #333;
}
>>> .reset1 .el-tabs__active-bar{
  left:18%
}
>>> .reset2 .el-tabs__active-bar{
  left:22%
}
>>> .el-tabs__item.is-active {
  color: #4b9afb;
}
>>> .el-form-item {
  margin-bottom: 39px;
}
>>> .el-tabs__item {
  height: 52px;
  font-size: 20px;
  margin-right:20px;
  padding:0
}
>>> .el-tabs__header {
  margin-bottom: 39px;
}
>>> .el-tabs__nav-wrap::after {
  background: #ffffff;
}
>>> .el-tabs__active-bar {
  height: 8px;
  background-color: #4b9afb;
  border-radius: 4px;
  opacity: 1;
  width: 24px !important
}
>>> .el-button--primary {
  padding: 20px 0;
  background: #4b9afb;
  font-size: 24px;
  border-radius: 8px;
}

@media screen and (max-device-height: 901px) {
  >>> .el-tabs__header {
      margin-bottom: 18px;
  }

  .title {
    margin: 0;
    font-size: 25px;
    padding-bottom: 15px;
  }
  .lgForm {
    width: 466px;
    margin: 0 auto;
    margin-top: 30px;
  }
  >>> .el-button--primary {
    padding: 15px 0;   
    font-size: 20px;  
  }
  >>> .el-form-item {
    margin-bottom: 30px;
  }
  .login-form {  
    width: 900px;
  }
  .lg-left {
    width: 320px;
  }
  >>> .el-input__inner {
    height: 50px;
    font-size: 14px;
  
  }
  .getcode>>> .el-button--primary{
    background:#ffffff;
    border:0;
    font-size: 14px;
  }
  .rulela {
    margin-bottom: 30px;
    color: #999;
    font-size: 16px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/Login.vue